import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import VideoGallerySliderModal from "./component";
import { withRouter } from "react-router-dom";
import withLogin from "../with-login";
import withWishlist from "../with-wishlist";
import { createClassifiedLead, createOrder, getCheckoutSteps, getIsStraightThroughEligble, getOrderDetail, getTradeInDetails, updateOrder, updateValidC2bOrder } from "../checkout-info/actions";
import { fetchCarDetails, fetchSimilarCars, setGsGalleryData } from "../car-details/actions";

const mapStateToProps = ({
    carDetails,
    carDetails: {
        content,
        leadAppointment
    },
    user: {
        secureToken,
        isUserZeroDpVariant,
        userGeoData,
        gaId,
        email,
        phoneNumberVerified
    },
    checkout: {
        order: { orderId, orderStatus, financeProvider, financeOpted, drivingLicenceStatus },
        order
    },
    preApprovalLoan: {
        preApproved,
        financeData: { preApprovalType }
    },
    abExperiment: {
        financeFirstCheckoutRevamp,
        desktopComingSoon
    },
    tradeIn: {
        tradeInToggleSelected,
        userTradeInData
    },
    config: {
        testDriveConfig
    }
}) => ({
    orderStatus,
    secureToken,
    orderId,
    preApproved,
    tradeInToggleSelected,
    financeProvider,
    isUserZeroDpVariant,
    financeFirstCheckoutRevamp,
    desktopComingSoon,
    order,
    preApprovalType,
    financeOpted,
    userTradeInData,
    drivingLicenceStatus,
    carDetails,
    userGeoData,
    testDriveConfig,
    content,
    gaId,
    email,
    phoneNumberVerified,
    leadAppointment
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updateOrderConnect: updateOrder,
            createOrderConnect: createOrder,
            getOrderDetailConnect: getOrderDetail,
            updateValidC2bOrderConnect: updateValidC2bOrder,
            getIsStraightThroughEligbleConnect: getIsStraightThroughEligble,
            getTradeInDetailsConnect: getTradeInDetails,
            fetchCarDetailsConnect: fetchCarDetails,
            setGsGalleryDataConnect: setGsGalleryData,
            fetchSimilarCarsConnect: fetchSimilarCars,
            getCheckoutStepsConnect: getCheckoutSteps,
            createClassifiedLeadConnect: createClassifiedLead
        },
        dispatch
    );

export default withLogin(withWishlist(withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoGallerySliderModal))));
